
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, class_type, int32_type, bool_type, list_type, record_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Label_$reflection } from "../../../Shared/Category.js";
import { RequestedValue$1_$reflection } from "../../../Shared/Shared.js";

export class LabelRow extends Record {
    constructor(Id, Name, ColorHex) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.ColorHex = ColorHex;
    }
}

export function LabelRow_$reflection() {
    return record_type("Settings.Categories.Overview.Types.LabelRow", [], LabelRow, () => [["Id", string_type], ["Name", string_type], ["ColorHex", string_type]]);
}

export class State extends Record {
    constructor(Categories, LabelTable, IsLabelColorSelectorOpen) {
        super();
        this.Categories = Categories;
        this.LabelTable = LabelTable;
        this.IsLabelColorSelectorOpen = IsLabelColorSelectorOpen;
    }
}

export function State_$reflection() {
    return record_type("Settings.Categories.Overview.Types.State", [], State, () => [["Categories", RequestedValue$1_$reflection(list_type(Label_$reflection()))], ["LabelTable", list_type(LabelRow_$reflection())], ["IsLabelColorSelectorOpen", bool_type]]);
}

export class HierarchicalLabel extends Record {
    constructor(Label, Depth, HierarchyPath) {
        super();
        this.Label = Label;
        this.Depth = (Depth | 0);
        this.HierarchyPath = HierarchyPath;
    }
}

export function HierarchicalLabel_$reflection() {
    return record_type("Settings.Categories.Overview.Types.HierarchicalLabel", [], HierarchicalLabel, () => [["Label", Label_$reflection()], ["Depth", int32_type], ["HierarchyPath", string_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CategoriesFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Categories.Overview.Types.Msg", [], Msg, () => [[["Item", list_type(Label_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

